import { render, staticRenderFns } from "./crmBlockTotal.vue?vue&type=template&id=19f1de2a&scoped=true&"
import script from "./crmBlockTotal.vue?vue&type=script&lang=js&"
export * from "./crmBlockTotal.vue?vue&type=script&lang=js&"
import style0 from "./crmBlockTotal.vue?vue&type=style&index=0&id=19f1de2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1de2a",
  null
  
)

export default component.exports